import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export const useIsEndorsementsPetitionEnabled = (): boolean => {
	const {
		data: {
			featureConfigs: { endorsementsPetitionEnabled },
		},
	} = usePetitionDetailsPageData();

	return !!endorsementsPetitionEnabled;
};
